import { ChatEndpoint } from '../services/api'
export interface AgentDefinition {
  id: ChatEndpoint
  name: string
  shortName: string
  description: string
  icon: string // emoji or lucide icon name
  color: string // tailwind color key
  bgClass: string
  textClass: string
  borderClass: string
  activeBgClass: string
  status: 'available' | 'beta' | 'deprecated' | 'coming_soon'
  badge?: string
  features: string[]
  latencyHint: string // e.g. "~2s", "~5-30s"
  provider: string
  recommended?: boolean
}
export const agentRegistry: AgentDefinition[] = [
  {
    id: 'agentfront',
    name: 'AgentFront Orchestrator',
    shortName: 'AgentFront',
    description:
      'Orquestación frontend con OpenAI + MCP Tools. Ejecuta herramientas de Confluence y Jira directamente.',
    icon: 'Workflow',
    color: 'emerald',
    bgClass: 'bg-emerald-950/40',
    textClass: 'text-emerald-400',
    borderClass: 'border-emerald-800/50',
    activeBgClass: 'bg-emerald-600',
    status: 'available',
    badge: 'MCP',
    features: ['Function Calling', 'Confluence', 'Jira', 'Tool Execution'],
    latencyHint: '~5-30s',
    provider: 'OpenAI + MCP',
    recommended: true,
  },
  {
    id: 'chat',
    name: 'Backend Chat Agent',
    shortName: '/chat',
    description:
      'Agente backend con orquestación server-side. Más rápido, procesamiento centralizado.',
    icon: 'Server',
    color: 'indigo',
    bgClass: 'bg-indigo-950/40',
    textClass: 'text-indigo-400',
    borderClass: 'border-indigo-800/50',
    activeBgClass: 'bg-indigo-600',
    status: 'available',
    features: ['Server Orchestration', 'Low Latency', 'Session Management'],
    latencyHint: '~2-5s',
    provider: 'AWS Lambda',
  },
  {
    id: 'query',
    name: 'Structured Query Agent',
    shortName: '/query',
    description:
      'Consultas estructuradas optimizadas para datos. Ideal para reportes y métricas.',
    icon: 'Database',
    color: 'violet',
    bgClass: 'bg-violet-950/40',
    textClass: 'text-violet-400',
    borderClass: 'border-violet-800/50',
    activeBgClass: 'bg-violet-600',
    status: 'beta',
    badge: 'Beta',
    features: ['Structured Data', 'Reports', 'Analytics'],
    latencyHint: '~2-5s',
    provider: 'AWS Lambda',
  },
  {
    id: 'invoke',
    name: 'Legacy Invoke Agent',
    shortName: '/invoke',
    description:
      'Endpoint legacy. Funcional pero sin las optimizaciones nuevas.',
    icon: 'Archive',
    color: 'slate',
    bgClass: 'bg-slate-800/40',
    textClass: 'text-slate-400',
    borderClass: 'border-slate-700/50',
    activeBgClass: 'bg-slate-600',
    status: 'deprecated',
    badge: 'Legacy',
    features: ['Basic Chat', 'Backward Compatible'],
    latencyHint: '~3-8s',
    provider: 'AWS Lambda (v1)',
  },
]
export function getAgent(id: ChatEndpoint): AgentDefinition {
  return agentRegistry.find((a) => a.id === id) || agentRegistry[0]
}
export function getAvailableAgents(): AgentDefinition[] {
  return agentRegistry.filter((a) => a.status !== 'coming_soon')
}
